import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { IconButton, Collapse as MUICollapse, Stack } from "@mui/material";
import PropTypes from "prop-types";

const Collapse = ({
  title,
  children,
  isExpandable = true,
  isDefaultExpanded = true,
  t,
}) => {
  const [isExpanded, setIsExpanded] = useState(isDefaultExpanded);

  const handleToggleCollapse = () => setIsExpanded((prev) => !prev);

  if (!isExpandable) {
    return (
      <>
        <div className="fs-4 fw-semibold mb-3">{t(title)}</div>
        <div>{children}</div>
      </>
    );
  }

  return (
    <>
      <div
        className="fs-4 fw-semibold mb-3 border-bottom cursor-pointer"
        onClick={handleToggleCollapse}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <div>{t(title)}</div>
          <IconButton>
            {isExpanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Stack>
      </div>
      <MUICollapse in={isExpanded} timeout="auto" unmountOnExit>
        {children}
      </MUICollapse>
    </>
  );
};

Collapse.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element,
  isDefaultExpanded: PropTypes.bool,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(Collapse);
